export const obtenerDataLocal =  ({clave}) => {


    let res = window.localStorage.getItem(clave);
   // console.log(res)

    if (!res) {
        return []
    }

    return JSON.parse(res)

}